export default {

  SET_SELECT_SECRETARY({commit},Secretary){
      commit('SET_SELECT_SECRETARY',Secretary)
  },
  SET_RESULT({commit},result){
      commit('SET_RESULT',result)
  },
  SET_EDIT_SECRETARY({commit},editSecretary){
      commit('SET_EDIT_SECRETARY',editSecretary)
  },
}